import axios, { AxiosRequestConfig } from 'axios'
import { set } from 'lodash'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '../config'
import { Modules } from "../util/modules";

interface RetryConfig extends AxiosRequestConfig {
  retry: number;
  retryDelay: number;
}

Vue.use(VueI18n)

export const Languages = {
  English_US: 'en-US',
  Danish: 'da',
  German: 'de',
  Spanish: 'es',
  Finnish: 'fi',
  French_Canada: 'fr-CA',
  French_France: 'fr-FR',
  Italian: 'it',
  Dutch: 'nl',
  Norwegian: 'no',
  Portuguese_Brazil: 'pt-BR',
  Portuguese_Portugal: 'pt-PT',
  Swedish: 'sv'
}

export const retryConfig: RetryConfig = {
  retry: 4, // total 5 retries
  retryDelay: 1000,
};

export const i18n = new VueI18n({
  locale: Languages.English_US,
  silentFallbackWarn: true,
})

axios.interceptors.response.use(undefined, (err) => {
  const { config, message } = err;
  if (!config || !config.retry) {
    return Promise.reject(err);
  }
  // retry while Network timeout or Network Error
  if (!(message.includes("timeout") || message.includes("Network Error"))) {
    return Promise.reject(err);
  }

  --config.retry;
  const delayRetryRequest = new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, config.retryDelay || 1000);
  });
  return delayRetryRequest.then(() => axios(config));
});

// Will be cached till refresh
const translationsStatus: Record<string, undefined | 'loaded' | 'loading' | 'failed'> = {}

export async function updateLocale(language: string, module: string = 'common') {
  const transformedLanguage = (function () {
    let transformedLanguage = language
    if (transformedLanguage.includes('_')) {
      console.warn(
        `Deprecated used of '_' in the language '${language}', please change to use hyphen '-'.`
      )
      transformedLanguage = transformedLanguage.replace('_', '-')
    }

    transformedLanguage = transformedLanguage.replace(/['"]/g, '')

    return transformedLanguage
  })()

  localStorage.setItem('locale', transformedLanguage)

  const localizationURL = `${config.localizationApiURL}/${transformedLanguage}?module=${module}`
  const cacheKey = `${module}_${transformedLanguage}`


 if(translationsStatus?.[cacheKey] === 'loading' ) {
  console.log(`%c ${cacheKey} is being loaded`, 'color:yellow;background-color:black');
  return false
 }

 if(translationsStatus?.[cacheKey] === 'loaded' ) {
  console.log(`%c ${cacheKey} has already loaded`, 'color:green;background-color:black');
  return false
 }

//  Set status
 set(translationsStatus, cacheKey, 'loading')

  await axios.get(localizationURL, retryConfig)
    .then(response => {
      const localJSONs = response.data
      i18n.locale = transformedLanguage
      i18n.fallbackLocale = Languages.English_US

      if (transformedLanguage !== Languages.English_US) {

        i18n.mergeLocaleMessage(
          transformedLanguage,
          localJSONs[transformedLanguage]
        )
      }

      i18n.mergeLocaleMessage(Languages.English_US, localJSONs[Languages.English_US])
      //  Set status
      set(translationsStatus, cacheKey, 'loaded')
    })
    .catch(error => {
      // Note: The 'error' is sent to Sentry after the API call is failed, even after retrying for 5 times
      console.error(`translations failed to load for ${cacheKey} -  ${JSON.stringify(error)}`)
      //  Set status
      set(translationsStatus, cacheKey, 'failed')
    })
}
